var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Button, Input, FormGroup, Label, Row, Col, Table } from 'reactstrap';
import cxs from 'cxs';
var styles = {
    blockTable: cxs({
        fontSize: '0.85rem',
    }),
    formContainer: cxs({
        marginTop: '12px',
        padding: '12px',
        backgroundColor: '#f8f9fa',
        borderRadius: '6px',
    }),
};
var BlocksSection = /** @class */ (function (_super) {
    __extends(BlocksSection, _super);
    function BlocksSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showForm: false,
            quantity: 1,
            reason: '',
        };
        _this.handleShowForm = function () {
            _this.setState({ showForm: true });
        };
        _this.handleHideForm = function () {
            _this.setState({
                showForm: false,
                quantity: 1,
                reason: '',
            });
        };
        _this.handleQuantityChange = function (e) {
            _this.setState({ quantity: parseInt(e.target.value, 10) || 1 });
        };
        _this.handleReasonChange = function (e) {
            _this.setState({ reason: e.target.value });
        };
        _this.handleSubmit = function () {
            var _a = _this.state, quantity = _a.quantity, reason = _a.reason;
            if (quantity > 0) {
                _this.props.onAddBlock({
                    quantity: quantity,
                    reason: reason || 'Sin especificar',
                });
                _this.handleHideForm();
            }
        };
        _this.handleRemove = function (blockId) {
            _this.props.onRemoveBlock(blockId);
        };
        return _this;
    }
    BlocksSection.prototype.renderBlocksTable = function () {
        var _this = this;
        var slot = this.props.slot;
        if (slot.blocks.length === 0) {
            return null;
        }
        return (React.createElement(Table, { size: "sm", className: styles.blockTable },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Cantidad"),
                    React.createElement("th", null, "Motivo"),
                    React.createElement("th", null, "Por"),
                    React.createElement("th", null))),
            React.createElement("tbody", null, slot.blocks.map(function (block) { return (React.createElement("tr", { key: block.id },
                React.createElement("td", null, block.quantity),
                React.createElement("td", null, block.reason),
                React.createElement("td", null, block.blocked_byName),
                React.createElement("td", null,
                    React.createElement(Button, { color: "danger", size: "sm", outline: true, onClick: function () { return _this.handleRemove(block.id); } }, "\u00D7")))); }))));
    };
    BlocksSection.prototype.renderForm = function () {
        var slot = this.props.slot;
        var _a = this.state, quantity = _a.quantity, reason = _a.reason;
        return (React.createElement("div", { className: styles.formContainer },
            React.createElement(Row, null,
                React.createElement(Col, { xs: 4 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { size: "sm" }, "Cantidad"),
                        React.createElement(Input, { type: "number", min: 1, max: slot.available > 0 ? slot.available : undefined, value: quantity, onChange: this.handleQuantityChange, bsSize: "sm" }))),
                React.createElement(Col, { xs: 8 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { size: "sm" }, "Motivo"),
                        React.createElement(Input, { type: "text", value: reason, onChange: this.handleReasonChange, placeholder: "Motivo del bloqueo...", bsSize: "sm" })))),
            React.createElement(Button, { color: "warning", size: "sm", onClick: this.handleSubmit }, "Confirmar bloqueo"),
            ' ',
            React.createElement(Button, { color: "secondary", size: "sm", outline: true, onClick: this.handleHideForm }, "Cancelar")));
    };
    BlocksSection.prototype.render = function () {
        var slot = this.props.slot;
        var showForm = this.state.showForm;
        if (slot.blocks.length === 0 && !showForm) {
            return (React.createElement("div", null,
                React.createElement("p", { className: "text-muted mb-2" }, "No hay plazas bloqueadas"),
                React.createElement(Button, { color: "warning", size: "sm", outline: true, onClick: this.handleShowForm }, "+ A\u00F1adir bloqueo")));
        }
        return (React.createElement("div", null,
            this.renderBlocksTable(),
            showForm ? (this.renderForm()) : (React.createElement(Button, { color: "warning", size: "sm", outline: true, className: "mt-2", onClick: this.handleShowForm }, "+ A\u00F1adir bloqueo"))));
    };
    BlocksSection = __decorate([
        observer
    ], BlocksSection);
    return BlocksSection;
}(Component));
export default BlocksSection;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Calendar/components/BlockSection.tsx
// module id = 1617
// module chunks = 0